module.exports = {"540629100":"尼玛镇","540629201":"卓尼乡","540629202":"达果乡","540629203":"阿索乡","540629204":"荣玛乡","540629205":"中仓乡","540629206":"来多乡","540629207":"申亚乡","540629208":"卓瓦乡","540629209":"俄久乡","540629210":"文部乡","540629211":"甲谷乡","540629212":"军仓乡","540629219":"吉瓦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540629.json
// module id = 2880
// module chunks = 0